<template lang="pug">
    .simple-keyboard-container(:class="{ capslock }")
        .simple-keyboard(ref="keyboard")
</template>

<script>
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";
import layout from "simple-keyboard-layouts/build/layouts/german";

export default {
    name: "Keyboard",
    props: {
        config: {
            type: Object,
            default: () => ({})
        },
        value: {
            default: undefined
        },
    },
    data() {
        return {
            keyboard: null,
            capslock: false,
            content: this.value,
        };
    },
    watch: {
        value(input) {
            this.keyboard.setInput(input);
        }
    },
    methods: {
        change(input) {
            this.$emit("change", input);
            this.$emit("input", input);
        },
        keyRelease(button) {
            this.$emit("key-release", button);

            switch (button) {
                // case '{enter}':
                case '{return}':
                    this.keyboard.dispatch((instance, key) => {
                        // instance.handleKeyUp(new KeyboardEvent('keyup', { key: 'Enter', code: 'Enter' }))
                    })
                    break;
            }
        },
        keyPress(button) {
            this.$emit("key-press", button);

            // const triggerMouseEvent = (node, eventType) => {
            //     var clickEvent = document.createEvent ('MouseEvents');
            //     clickEvent.initEvent (eventType, true, true);
            //     node.dispatchEvent (clickEvent);
            // }

            switch (button) {
                case '{shift}':
                case '{shiftleft}':
                case '{shiftright}':
                    this.handleShift();
                    break;

                case '{lock}':
                case '{capslock}':
                    this.handleCapsLock();
                    break;

                case '{enter}':
                    this.keyboard.dispatch((instance, key) => {
                        instance.getButtonElement('{return}').classList.add(instance.activeButtonClass);
                    })
                    break;
                case '{return}':
                    this.keyboard.dispatch((instance, key) => {
                        // instance.handleKeyDown(new KeyboardEvent('keydown', { key: 'a' }))
                        // instance.handleButtonMouseDown('a', triggerMouseEvent(instance.getButtonElement('a')), 'mousedown')
                        instance.getButtonElement('{enter}').classList.add(instance.activeButtonClass);
                        instance.handleButtonClicked('{enter}', new KeyboardEvent('keydown', { key: 'Enter' }))
                    })
                    break;
            }

            // button.match(/^\{.+\}$/) === null
            if (! (button.includes("{") && button.includes("}"))
                && this.keyboard.options.layoutName === 'shift'
                && this.capslock === false
            ) {
                this.handleShift()
            }
        },
        handleShift() {
            let currentLayout = this.keyboard.options.layoutName;
            let shiftToggle = currentLayout === "default" ? "shift" : "default";

            if (shiftToggle === 'default') this.capslock = false

            this.keyboard.setOptions({
                layoutName: shiftToggle
            });
        },
        handleCapsLock() {
            this.capslock = ! this.capslock
            this.handleShift()
        },
        handlePhysicalKeyDown(event) {
            if (event.key === 'Enter') {
                this.keyboard.dispatch((instance, key) => {
                    const options = instance.getOptions()
                    if (options.physicalKeyboardHighlight) {
                        const button = instance.getButtonElement('{return}')
                        button.style.background = options.physicalKeyboardHighlightBgColor || "#dadce4";
                        button.style.color = options.physicalKeyboardHighlightTextColor || "black";
                    }
                })
            }
        },
        handlePhysicalKeyUp(event) {
            if (event.key === 'Enter') {
                this.keyboard.dispatch((instance, key) => {
                    const options = instance.getOptions()
                    if (options.physicalKeyboardHighlight) {
                        const button = instance.getButtonElement('{return}')
                        button.removeAttribute("style")
                    }
                })
            }
        },
    },
    mounted() {
        this.keyboard = new Keyboard(this.$refs.keyboard, {
            onChange: this.change,
            onKeyPress: this.keyPress,
            onKeyReleased: this.keyRelease,
            preventMouseDownDefault: true,
            physicalKeyboardHighlight: true,
            // debug: true,
            // layout: {
            //     default: [
            //         "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
            //         "{tab} q w e r t y u i o p [ ] \\",
            //         "{lock} a s d f g h j k l ; ' {enter}",
            //         "{shift} z x c v b n m , . / {shift}",
            //         "{space}"
            //     ],
            //     shift: [
            //         "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
            //         "{tab} Q W E R T Y U I O P { } |",
            //         '{lock} A S D F G H J K L : " {enter}',
            //         "{shift} Z X C V B N M < > ? {shift}",
            //         "{space}"
            //     ]
            // },
            layout: {
                default: [
                    '^ 1 2 3 4 5 6 7 8 9 0 ß ´ {backspace}',
                    '{tab} q w e r t z u i o p ü + {return}',
                    '{lock} a s d f g h j k l ö ä # {enter}',
                    '{shiftleft} < y x c v b n m , . - {shiftright}',
                    '{altleft} @ .de {space} {meta} {altright}'
                ],
                shift: [
                    '° ! " § $ % & / ( ) = ? ` {backspace}',
                    '{tab} Q W E R T Z U I O P Ü * {return}',
                    '{lock} A S D F G H J K L Ö Ä \' {enter}',
                    '{shiftleft} > Y X C V B N M ; : _ {shiftright}',
                    '{altleft} € .com {space} {meta} {altright}'
                ]
            },
            display: {
                // "{escape}": "Esc",
                // "{tab}": "Tab ⇥",
                // "{backspace}": "⟻ Backspace",
                // "{enter}": "Enter ↵",
                // "{capslock}": "CapsLock ⇪",
                // "{shiftleft}": "Shift ⇧",
                // "{shiftright}": "Shift ⇧",
                // "{controlleft}": "Ctrl ⌃",
                // "{controlright}": "Ctrl ⌃",
                // "{altleft}": "Alt ⌥",
                // "{altright}": "Alt ⌥",
                // "{metaleft}": "Cmd ⌘",
                // "{metaright}": "Cmd ⌘"
                "{tab}": "⇥",
                "{bksp}": "⟵",
                "{backspace}": "⟵",
                "{enter}": " ",
                "{return}": "↵",
                "{lock}": "⇪",
                "{shift}": "⇧",
                "{shiftleft}": "⇧",
                "{shiftright}": "⇧",
                "{space}": " ",
                "{alt}": "⌥",
                "{altleft}": "⌥",
                "{altright}": "⌥",
                "{ctrl}": "Ctrl",
                "{meta}": "⌘"
            },
            // ...layout,
            ...this.config
        });

        document.addEventListener('keydown', this.handlePhysicalKeyDown);
        document.addEventListener('keyup', this.handlePhysicalKeyUp);
    },
    beforeDestroy() {
        setTimeout(this.keyboard.destroy, 400)
        window.removeEventListener('keydown', this.handlePhysicalKeyDown)
        window.removeEventListener('keyup', this.handlePhysicalKeyUp)
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.simple-keyboard:deep()
    background: none
    padding: 0
    .hg-button-space
        width: calc(90% - 300px)
        // width: 50%
    .hg-button-tab
        width: 6%
    .hg-button-backspace
        width: 7%
    .hg-button-lock,
    .hg-button-capslock
        width: 8%
    .hg-button-shift
        width: 10%
    .hg-button-shiftleft
        width: 5%
    .hg-button-shiftright
        width: 12%
    // .hg-button-return,
    // .hg-button-enter,
    /* .hg-button-tab, */
    .hg-button-altleft,
    .hg-button-altright,
    .hg-button-ctrl,
    .hg-button-meta
        pointer-events: none
        background: darken($color-skeleton, 5%) !important
        /* box-shadow: none */
    .hg-button-altright,
    .hg-button-meta
        width: 6%
    .hg-button-return
        width: 4%
        border-bottom-right-radius: 0
    .hg-button-enter
        width: 2%
        height: 46px
        border-top-left-radius: 0
        border-top-right-radius: 0
        top: -6px
        position: relative
        margin-bottom: -6px
        &:after
            content: ''
            position: absolute
            left: 0
            width: 100%
            top: -2px
            height: 4px
            background: inherit

.simple-keyboard-container:deep()
    .hg-button-lock,
    .hg-button-capslock
        position: relative
        &:after
            content: ''
            position: absolute
            left: 6px
            top: 6px
            width: 5px
            height: 5px
            border-radius: 50%
            background: $--color-info

.simple-keyboard-container.capslock:deep()
    .hg-button-lock,
    .hg-button-capslock
        &:after
            background: $--color-success
</style>
